import { Decorators } from "../Decorators";

@Decorators.registerInterface('Serenity.IAsyncInit')
export class IAsyncInit {
}